module.exports = __webpack_public_path__ + "static/media/nike-what-will-they-say-about-you.8a5dfb5a.mp4";